import { Node } from 'reactflow';

export const sortNodes = (a: Node, b: Node): number => {
  if (a.type === b.type) {
    return 0;
  }
  return a.type === 'nodesGroup' && b.type !== 'nodesGroup' ? -1 : 1;
};
